// 枚举类型
export const enum DataScope {
  All = 0,
  Custom = 1,
  Dept = 2,
  DeptAndDown = 3,
  Self = 4
}

export const enum RecordStatus {
  Disabled = 0,
  Enabled = 1
}

export const enum LeakStatus {
  Unreported = 0, // 未上报
  NeedAssignRepairDept = 1, // 待分配
  NeedAssignRepairUser = 2, // 待认领
  Repairing = 3, // 维修中
  Repaired = 4, // 完成维修
  CantRepair = 5, // 无法维修
  NoNeedRepair = 6 // 无需维修
}

export function GetLeakStatus(status: LeakStatus) {
  switch (status) {
    case LeakStatus.Unreported:
      return '未上报'
    case LeakStatus.NeedAssignRepairDept:
      return '待分配'
    case LeakStatus.NeedAssignRepairUser:
      return '待认领'
    case LeakStatus.Repairing:
      return '维修中'
    case LeakStatus.Repaired:
      return '完成维修'
    case LeakStatus.CantRepair:
      return '无法维修'
    case LeakStatus.NoNeedRepair:
      return '无需维修'
    default:
      return '未知'
  }
}

export const enum RepairType {
  Other = 0, // 其他
  BeforeMeter = 1, // 表前
  AfterMeter = 2, // 表后
  OutSideNets = 3, // 网外
  Empty = 4, // 挖空
  Internal = 5, // 内部
  ChangePipe = 6 // 改管
}

export function GetRepairType(type: RepairType) {
  switch (type) {
    case RepairType.Other:
      return '其他'
    case RepairType.BeforeMeter:
      return '表前'
    case RepairType.AfterMeter:
      return '表后'
    case RepairType.OutSideNets:
      return '网外'
    case RepairType.Empty:
      return '挖空'
    case RepairType.Internal:
      return '内部维修'
    case RepairType.ChangePipe:
      return '改管'
    default:
      return '-'
  }
}


export const enum DeptType {
  Other = 0,
  Detect = 1,
  Repair = 2
}

// 基础接口
export interface IPoint {
  longitude: number
  latitude: number
}

export const enum FileType {
  CheckImage = 0,
  ReferenceImage = 1,
  CheckVideo = 2,
  RepairImage = 3,
  RepairVideo = 4
}

export interface ILeakFile {
  filePath: string
  fileType: FileType
}

// 用户相关接口
export interface IUser {
  id: number
  username: string
  phone: string
  wechat: string
  status: RecordStatus
  createTime: string
  updateTime: string
}


// 角色相关接口
export interface IRole {
  id: number
  name: string
  desc: string
  createTime: string
  updateTime: string
}

// 租户相关接口
export interface IOrg {
  id: number
  name: string
  status: RecordStatus
  createTime: string
  updateTime: string
  realAdminId: number
  orgConfig?: any
}

// 部门相关接口
export interface IDept {
  id: number
  name: string
  parentId: number
  deptPrefix: string
  status: RecordStatus
  type: DeptType
  createTime: string
  updateTime: string
}


// 漏点相关接口
export interface ILeakDetection {
  id: number
  roadInfo: string
  size: number
  material: string
  location: IPoint
  referenceAddr: string
  detailAddr: string
  checkUserId: number
  updateTime: string
  reportTime: string
  sizePrice: number
  files?: ILeakFile[]
}

// 简单漏点
export interface ISimpleLeakPoint {
  id: number
  index: string
  leakStatus: number
  location: IPoint
}

export interface ILeakRepair {
  id: number
  repairType: number
  part: string
  reason: string
  leakLeakage: number
  depth: number
  repairTime: string
  repairUserId: number
  updateTime: string
  roadInfo: string
  size: number
  material: string
  sizePrice: number
  files?: ILeakFile[]
}

export interface ILeakPoint {
  id: number
  index: string
  leakStatus: number
  projectId: number
  repairDeptId: number
  createTime: string
  updateTime: string
  detection?: ILeakDetection
  repair?: ILeakRepair
}

// 基础数据相关接口
export interface IPipeDiameter {
  id: number
  name: string
  size: number
  price: number
}

export interface IPipeMaterial {
  id: number
  name: string
}

export interface IRoadSurface {
  id: number
  name: string
}

export interface ILeakPosition {
  id: number
  name: string
}

export interface ILeakReason {
  id: number
  desc: string
}

// Response
export interface IUserDeptInfo {
  dept: IDept
  isLeader: boolean
}

export interface IDeptUserInfo {
  user: IUser
  isLeader: boolean
}

export interface IAllRoleInfo {
  role: IRole
  permissions: string[]
  dataScope: DataScope
  customDepts: IDept[]
}

export interface IAllUserInfo {
  user: IUser
  orgs: IOrg[]
  depts: IUserDeptInfo[]
  roles: IAllRoleInfo[]
  permissions: string[]
  currentOrg: IOrg
  projects: IProject[]
}

export interface IAllDeptInfo {
  dept: IDept
  users: IDeptUserInfo[]
  children: IAllDeptInfo[]
  projects: IProject[]
}

export interface IProject {
  id: number
  name: string
  prefix: string
  status: RecordStatus
  deptId: number
  createTime: string
  updateTime: string
}

export interface IAllProjectInfo {
  project :IProject
  dept: IDept
}

export interface ICredentials {
  sessionToken: string
  buket: string
  region: string
  endpoint: string
  paths: string[]
  expireTime: number
}

// 添加获取漏点文件的相关接口
export interface GetFilesByLeakIdParams {
  leakId: number
  fileType?: FileType
}

export interface UploadFileParams {
  leakId: number
  fileType: FileType
  file: File
}

export interface DeleteFileParams {
  fileId: number
}